module.exports = __webpack_public_path__ + "static/media/chevron-double-left.abdbf02b.svg";